import { Injectable } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs';

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/compat/firestore';

import { SelectExhibits } from './firestore-models/user';
import { Project } from './firestore-models/project';
import { Notice } from './firestore-models/notice';

import { AppConst } from './app-const';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private projectId!: string;
  private projectName!: string;
  private projectIdSubject = new Subject<string>();
  public projectIdSubject$ = this.projectIdSubject.asObservable();
  private project!: Project;
  private projectsDocument!: AngularFirestoreDocument<Project>;
  // private projectsObservable!: Observable<Project>;
  private projectsSubscribe!: Subscription;

  private noticesCollection!: AngularFirestoreCollection<Notice>;
  noticesObservable!: Observable<Notice[]>;
  noticesSubscribe!: Subscription;
  private newNoticesSubject = new Subject<boolean>();
  public newNoticesSubject$ = this.newNoticesSubject.asObservable();

  private userType!: number;
  private exhibitIds!: Array<SelectExhibits>;
  private isEdit!: boolean;

  private threadId!: string;

  private reservationFacilityId!: string;
  private reservationUnit!: number;

  constructor(
    private angularFirestore: AngularFirestore
  ) { }

  ngOnDestroy(): void {
    this.clearSubscribe();
  }

  public getProjectId(): string {
    return this.projectId;
  }

  public getProject(): Project {
    return this.project;
  }

  public setProjectId(projectId: string): void {
    this.projectId = projectId;
    if (this.projectId != '') {
      this.subscribeProject();
    } else {
      this.clearSubscribe();
    }
    this.onNotifyProjectIdChanged();
    this.getNotices();
  }

  public getProjectName(): string {
    return this.projectName;
  }

  public setProjectName(projectName: string): void {
    this.projectName = projectName;
  }

  private onNotifyProjectIdChanged(): void {
    this.projectIdSubject.next(this.getProjectId());
  }

  private subscribeProject(): void {
    this.projectsDocument = this.angularFirestore.doc<Project>(`${AppConst.FIRESTORE_PROJECTS}/${this.projectId}`);
    this.projectsSubscribe = this.projectsDocument.valueChanges().subscribe(project => {
      this.project = project!;
    });
  }

  private clearSubscribe(): void {
    if (!!this.projectsSubscribe) {
      this.projectsSubscribe.unsubscribe();
    }
    this.projectsDocument = null as any;
    // this.projectsObservable = null;
    this.projectsSubscribe = null as any;
    this.project = null as any;
  }

  // 通知取得
  private getNotices(): void {
    this.noticesCollection = this.angularFirestore.collection<Notice>(
      AppConst.FIRESTORE_NOTICES, ref => ref.where('project_ids', 'array-contains', this.projectId));
    this.noticesObservable = this.noticesCollection.valueChanges({ idField: 'id' });
    this.noticesSubscribe = this.noticesObservable.subscribe(notices => {
      this.newNoticesSubject.next(false);
      if (notices) {
        for (let notice of notices) {
          if (!notice.confirmed.includes(this.projectId)) {
            this.newNoticesSubject.next(true);
          }
        }
      }
    });    
  }

  public setUserType(val: number): void {
    this.userType = val;
  }

  public getUserType(): number {
    return this.userType;
  }

  public setExhibitIds(val: Array<SelectExhibits>): void {
    this.exhibitIds = val;
  }

  public getExhibitIds(): Array<SelectExhibits> {
    return this.exhibitIds;
  }

  public setIsEdit(val: boolean): void {
    this.isEdit = val;
  }

  public getIsEdit(): boolean {
    return this.isEdit;
  }

  public setThreadId(val: string): void {
    this.threadId = val;
  }

  public getThreadId(): string {
    return this.threadId;
  }

  public getReservationFacilityId(): string {
    return this.reservationFacilityId;
  }

  public setReservationFacilityId(reservationFacilityId: string): void {
    this.reservationFacilityId = reservationFacilityId;
  }

  public getReservationUnit(): number {
    return this.reservationUnit;
  }

  public setReservationUnit(reservationUnit: number): void {
    this.reservationUnit = reservationUnit;
  }

}
